// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"6fbd6622","318":"68d27e92","390":"fe3eb350","771":"1979c702","787":"6db2d9b6","842":"39525f7d","921":"4573c073"}[chunkId] + ".chunk.js";
};